/**
 * Quality dropdown — bottom-right pill next to the FPS overlay. Lets the
 * user override the adaptive controller. "Auto" hands control back to the
 * FPS-driven knob ladder. The stand demo puts it in the toolbar row instead,
 * left of the Scenes button (`before`), as a 36 px bubble (viewer.css).
 */

import type { AdaptiveQualityController, QualityMode } from '../quality/adaptive-quality';

const MODES: { value: QualityMode; label: string }[] = [
    { value: 'auto',   label: 'Auto' },
    { value: 'high',   label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low',    label: 'Low' }
];

export class QualityDropdown {

    private root: HTMLDivElement;

    private select: HTMLSelectElement;

    private controller: AdaptiveQualityController;

    constructor(controller: AdaptiveQualityController, parent: HTMLElement, before: Element | null = null) {
        this.controller = controller;

        this.root = document.createElement('div');
        this.root.className = 'quality-dropdown';

        const label = document.createElement('span');
        label.className = 'label';
        label.textContent = 'Quality';

        this.select = document.createElement('select');
        for (const m of MODES) {
            const opt = document.createElement('option');
            opt.value = m.value;
            opt.textContent = m.label;
            this.select.appendChild(opt);
        }
        this.select.value = controller.currentMode;
        this.select.addEventListener('change', () => {
            controller.setMode(this.select.value as QualityMode);
        });

        this.root.appendChild(label);
        this.root.appendChild(this.select);
        parent.insertBefore(this.root, before);
    }

    setVisible(v: boolean): void {
        this.root.style.display = v ? '' : 'none';
    }
}
